module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/padlock-icon-50888bf5.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/padlock-icon.svg
// module id = ./app/web/src/assets/padlock-icon.svg
// module chunks = 0